import { PeriodResultKind } from '@/entities/result';
import type { PeriodResult } from '@/entities/result';

import type { ResultVariantId } from './variants';

/**
 * Какая из девяти раскладок подходит итогу.
 *
 * Сервер отдаёт факты, а не вариант: доменных сценариев меньше, чем
 * раскладок — «первое место» и «второе» отличаются оформлением, а не
 * правилом игры.
 *
 * `freebets_forfeited` (Фрибеты сгорели без подписки) отдельной раскладки
 * в макете не имеет и попадает в `weekly-second`: там уже есть счётчик
 * Очков, а про сгоревшие Фрибеты игроку пишет бот отдельным сообщением
 * с кнопкой «Подписаться».
 */
export function variantOf(result: PeriodResult): ResultVariantId {
  if (result.kind === PeriodResultKind.WEEKLY_TOURNAMENT) {
    if (result.rank === 1) return 'weekly-first';

    const rewarded =
      result.pointsAwarded > 0 ||
      result.freebetsAwarded > 0 ||
      result.freebetsForfeited > 0;
    return rewarded ? 'weekly-second' : 'weekly-other';
  }

  if (result.isWinner) {
    // Физический приз и поездка показываются с названием, чистые Фрибеты —
    // счётчиком: в макете это две разные карточки
    return result.prizeKind === 'FREEBETS' ? 'monthly-second' : 'monthly-main';
  }

  return result.rank === 1 ? 'monthly-first' : 'monthly-other';
}
